import React from 'react';

const VideoIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g transform="translate(0)"><rect width="24" height="24" fill="none"/><path d="M42.135,5.854a46.713,46.713,0,0,1,9.041.07l.777.082a3.319,3.319,0,0,1,2.926,2.746l4.193-2.228a.959.959,0,0,1,1.406.763l.032.363a70.032,70.032,0,0,1,0,12.231l-.032.363a.959.959,0,0,1-1.406.763L54.879,18.78a3.319,3.319,0,0,1-2.926,2.746l-.777.082a46.713,46.713,0,0,1-9.041.07L40.112,21.5a3.306,3.306,0,0,1-2.977-2.815,33.972,33.972,0,0,1,0-9.831,3.307,3.307,0,0,1,2.977-2.815ZM55.116,16.793a.959.959,0,0,1,.3.1l3.268,1.736a68.1,68.1,0,0,0,0-9.727l-3.268,1.736a.958.958,0,0,1-.3.1A34.13,34.13,0,0,1,55.116,16.793Z" transform="translate(-36.777 -1.668)" fill="#24a0dc" fillRule="evenodd"/></g></svg>
  );
};

export default VideoIcon;
